<template>
  <div class="mask" @click="fn">
    <div ref="bigBox" class="container" @click.stop>
      <p class="✕" @click="fn">✕</p>

      <div class="boxItem">
        <p class="boxTitle">跳转类型：</p>
        <Select
          class="w-200"
          v-model:value="jumpType"
          :options="typeOptions"
        ></Select>
      </div>

      <div class="boxItem">
        <p class="boxTitle">跳转地址：</p>
        <Input allowClear v-model:value="addressJump" class="w-400" />
      </div>

      <a
        v-if="jumpType === 'app'"
        target="_blank"
        href="https://o15vj1m4ie.feishu.cn/wiki/wikcnH0UmDnOI42nF6LrGf809KY"
        class="link ml-80"
        >app原生跳转/参数汇总文档</a
      >

      <div v-if="jumpType === 'h5'" class="boxItem">
        <p class="boxTitle">通用选项：</p>
        <div>
          <Select
            @change="filterOption"
            v-model:value="common"
            allowClear
            mode="multiple"
            :options="options"
            class="w-400"
          />

          <div
            class="lineBox"
            v-if="common.some((item) => item.includes('aspect_ratio'))"
          >
            <p>宽高比：750 /</p>
            <InputNumber
              class="ml-10"
              id="inputNumber"
              v-model:value="height"
            />
            <p class="redText">【页面在半屏场景的宽高比（750/页面的高度）】</p>
          </div>

          <div
            class="lineBox"
            v-if="common.some((item) => item.includes('height_ratio'))"
          >
            <p>高度比例：</p>
            <InputNumber class="ml-10" v-model:value="heightRatio" />
          </div>

          <div
            class="lineBox"
            v-if="common.some((item) => item.includes('present_contentColor'))"
          >
            <p>背景色：</p>
            <Input class="w-200" v-model:value="contentColor" />
            <a
              class="link"
              target="_blank"
              href="https://o15vj1m4ie.feishu.cn/wiki/IGeOwnV2ciSwWokAsPqcg2OrnQh"
              >色值可参考此文档</a
            >
          </div>

          <div
            class="lineBox"
            v-if="common.some((item) => item.includes('web_loading_backcolor'))"
          >
            <p>加载过程背景色：</p>
            <Input class="w-200" v-model:value="loadColor" />
            <a
              class="link"
              target="_blank"
              href="https://o15vj1m4ie.feishu.cn/wiki/IGeOwnV2ciSwWokAsPqcg2OrnQh"
              >色值可参考此文档</a
            >
          </div>
        </div>
      </div>

      <div v-if="jumpType === 'h5'" class="boxItem">
        <p class="boxTitle">地址参数：</p>
        <div>
          <Input allowClear v-model:value="addressParams" class="w-400 mb-10" />
          <p class="mb-10 redText">规则：多个参数用&隔开。如：</p>
          <Input
            :value="'type=price&title=车库商店&productLevel=1'"
            disabled
            class="w-400"
          />
        </div>
      </div>

      <Alert
        type="warning"
        v-if="jumpType === 'app' && addressJump.startsWith('http')"
        class="alert"
        message="如果是要在客户端内跳转到网页请选择［跳转H5］"
      />

      <div class="boxItem end">
        <p class="boxTitle">最终地址：</p>
        <div class="textarea">
          {{ lastVal }}
        </div>
        <div class="copyBtn ml-10" @click="copy">复制</div>
      </div>

      <div class="flex">
        <button class="ant-btn ant-btn-default" @click="fn">取消</button>
        <button
          @click="emit('ok', lastVal)"
          class="ml-10 mr-10 ant-btn ant-btn-primary"
        >
          确认
        </button>
      </div>

      <InputNumber class="none" />
      <Alert class="none" message="sss" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, defineProps, onMounted, defineEmits } from "vue";
import {
  Alert,
  Input,
  Select,
  InputNumber,
  Modal,
  message,
} from "ant-design-vue";

const props = defineProps<{
  url: string;
  open: boolean;
}>();

const options = ref([
  { label: "全屏展示、隐藏半屏的返回按钮（隐藏导航栏）", value: "hide_nav=1" },
  { label: "半屏展示", value: "present=1", disabled: false },
  { label: "禁用离线包", value: "h5_offline=0" },
  { label: "隐藏全屏按钮", value: "hide_full=1" },
  { label: "网页容器透明", value: "is_transparent=1" },
  { label: "右上角带分享按钮", value: "showShareBtn=1", disabled: false },
  { label: "宽高比", value: `aspect_ratio=` },
  { label: "网页容器之外背景色", value: `present_contentColor=` },
  { label: "网页跟随软键盘", value: `can_float=1` },
  { label: "网页容器不圆角", value: `hide_corner=1` },
  { label: "手势右滑直接退出页面", value: `close_wv_by_gesture=1` },
  { label: "禁用容器弹性效果", value: `bounce_disable=1` },
  { label: "开启 http 缓存", value: `x_cache=1` },
  { label: "高度比例", value: `height_ratio=` },
  { label: "加载过程背景色", value: `web_loading_backcolor=` },
]);

const typeOptions = [
  { label: "跳转H5", value: "h5" },
  { label: "app原生跳转/自定义跳转", value: "app" },
];

const emit = defineEmits(["ok", "cancel"]);

const fn = () => {
  Modal.confirm({
    title: "关闭将丢失编辑内容",
    content: "你确定要关闭吗？",
    okText: "确定",
    cancelText: "取消",
    zIndex: 5001,
    onOk() {
      // console.log('OK');
      // jumpType.value = 'h5'
      // addressJump.value = ''
      // common.value = []
      // addressParams.value = ''
      emit("cancel");
    },
    onCancel() {
      console.log("Cancel");
    },
  });
};

const copy = () => {
  navigator.clipboard
    .writeText(lastVal.value)
    .then(() => {
      console.log("Text copied to clipboard");
      message.success("复制成功");
    })
    .catch((err) => {
      console.error("Error in copying text: ", err);
    });
};

const contentColor = ref("#000000B3");
const loadColor = ref("#00000000");
const common = ref<string[]>([]);
const jumpType = ref("h5");
const addressParams = ref("");
const addressJump = ref("");
const height = ref(1136);
const heightRatio = ref(1);
const bigBox = ref<HTMLDivElement>();

const filterOption = (aa: unknown[]) => {
  options.value[5].disabled = aa.includes("present=1");
  options.value[1].disabled = aa.includes("showShareBtn=1");
  return true;
};

const ratio = computed(() => {
  return (750 / height.value).toFixed(4);
});

const lastVal = computed(() => {
  if (jumpType.value === "h5") {
    let query = addressJump.value;
    if (addressParams.value) {
      query = encodeURIComponent(
        `${addressJump.value ? addressJump.value + "?" : ""}${
          addressParams.value
        }`
      );
    }
    const arr = common.value.map((item) => {
      if (item.includes("aspect_ratio")) {
        item = `aspect_ratio=${ratio.value}`;
      }
      if (item.includes("present_contentColor")) {
        item = `present_contentColor=${encodeURIComponent(contentColor.value)}`;
      }
      if (item.includes("web_loading_backcolor")) {
        item = `web_loading_backcolor=${encodeURIComponent(loadColor.value)}`;
      }
      if (item.includes("height_ratio")) {
        item = `height_ratio=${heightRatio.value}`;
      }
      return item;
    });
    return `${arr.join("&")}${arr.length ? "&" : ""}m=web&a=url&ul=${query}`;
  } else {
    return addressJump.value;
  }
});

const parse = () => {
  try {
    const path = props.url;
    if (!path) return;

    if (
      !path.includes("&ul=") ||
      !path.includes("m=web") ||
      !path.includes("a=url")
    ) {
      jumpType.value = "app";
      addressJump.value = path;
      return;
    }

    let str = "m=web&a=url&ul=";

    if (path.includes("m=web&a=url&ul=") === false) {
      str = "&ul=";
    }
    const [one, two] = path.split(str);
    const url = decodeURIComponent(two);
    const [fir, sec] = url.split("?");
    if (fir && fir !== "undefined") {
      addressJump.value = fir;
    }
    if (sec && sec !== "undefined") {
      addressParams.value = sec;
    }
    common.value.length = 0;
    one.split("&").forEach((item) => {
      if (item.includes("aspect_ratio")) {
        const ratio = Number(item.split("=")[1]);
        height.value = Number((750 / ratio).toFixed(0));
        common.value.push("aspect_ratio=");
      } else if (item.includes("present_contentColor")) {
        contentColor.value = decodeURIComponent(item.split("=")[1]);
        common.value.push("present_contentColor=");
      } else if (item.includes("web_loading_backcolor")) {
        loadColor.value = decodeURIComponent(item.split("=")[1]);
        common.value.push("web_loading_backcolor=");
      } else if (item.includes("height_ratio")) {
        heightRatio.value = Number(item.split("=")[1]);
        common.value.push("height_ratio=");
      } else if (
        item !== "m=web" &&
        item !== "a=url" &&
        item !== "hide_nav=0" &&
        item
      ) {
        common.value.push(item);
      }
    });
  } catch (error) {
    console.log("🦊 ~ error:", error);
  }
};

onMounted(() => {
  parse();
  document.querySelectorAll("style").forEach((item) => {
    if (item.getAttribute("data-cache-path")?.includes("rm38b5")) {
      bigBox.value?.appendChild(item.cloneNode(true));
    }
    if (item.getAttribute("data-token-hash") === "rm38b5") {
      bigBox.value?.appendChild(item.cloneNode(true));
    }
    if (item.getAttribute("data-css-hash")?.includes("1qb1s0s")) {
      bigBox.value?.appendChild(item.cloneNode(true));
    }
  });
  console.log("🦊 ~ bigBox:", props);
});
</script>

<script lang="ts">
export default {
  name: "behind-jump",
};
</script>

<style scoped>
.✕ {
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
  font-size: 20px;
  color: #333;
  z-index: 4999;
}

.alert {
  margin-left: 80px;
  margin-right: 55px;
  margin-top: 10px;
}

.copyBtn {
  color: #1890ff;
  cursor: pointer;
  font-size: 12px;
  height: 100%;
}

p {
  font-size: 14px;
  color: #333;
  margin-bottom: 0px;
  margin-top: 0px;
}

.textarea {
  width: 400px;
  height: 120px;
  border: 1px solid #d9d9d9;
  padding: 10px;
  border-radius: 6px;
  overflow-y: auto;
  position: relative;
  overflow-x: hidden;
  word-break: break-all;
  padding-bottom: 24px;
}

.flex {
  display: flex;
  justify-content: flex-end;
}

.mask {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 4999;
  background-color: #33333390;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
}

.container {
  background-color: white;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  border-radius: 10px;
  margin-top: -5%;
  height: 70%;
  overflow-y: auto;
}

.redText {
  color: red;
  font-size: 12px;
}

.link {
  color: #1890ff;
  cursor: pointer;
  font-size: 14px;
  margin-left: 8px;
}

.mb-10 {
  margin-bottom: 10px;
}

.ml-10 {
  margin-left: 10px;
}

.mr-10 {
  margin-right: 10px;
}

.w-200 {
  width: 200px;
}

.w-400 {
  width: 400px;
}

.boxItem {
  display: flex;
  align-items: baseline;
  margin: 20px 0;
}

.boxTitle {
  width: 80px;
}

.lineBox {
  display: flex;
  align-items: center;
  margin: 10px;
}

.none {
  display: none;
}

.ant-btn {
  font-size: 14px;
  height: 32px;
  padding: 4px 15px;
  border-radius: 6px;
}

.ant-btn {
  outline: none;
  position: relative;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  background-color: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  touch-action: manipulation;
  line-height: 1.5714285714285714;
  color: rgba(0, 0, 0, 0.88);
}

.ant-btn-primary {
  color: #fff;
  background-color: #1677ff;
  box-shadow: 0 2px 0 rgba(5, 145, 255, 0.1);
}

.ant-btn-default {
  background-color: #ffffff;
  border-color: #d9d9d9;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
}

.ml-80 {
  margin-left: 80px;
}
</style>

<style>
:where(.css-dev-only-do-not-override-1qb1s0s).ant-modal-root .ant-modal-mask {
  z-index: 5000;
}

.ant-modal-wrap {
  z-index: 5001;
}
</style>
